import { getScriptParamsByURL } from "../main";
const COMMON_LAST_CLICKED_PRODUCTS = "fs-last-clicked-product-data";
export default function getProductPageID(platform) {
    if (COMMON_LAST_CLICKED_PRODUCTS in localStorage) {
        const { productID, productURL } = JSON.parse(localStorage.getItem(COMMON_LAST_CLICKED_PRODUCTS));
        if (window.location.href.includes(productURL)) {
            return productID;
        }
    }
    switch (platform) {
        case "Shopify": {
            return getShopifyProductID();
        }
        case "BigCommerce": {
            return getBigCommerceProductID();
        }
        case "WooCommerce": {
            return getWooCommerceProductID();
        }
        case "Magento": {
            return getMagentoProductID();
        }
    }
    return "";
}
function getShopifyProductID() {
    if (typeof __st != 'undefined' && __st.rid && __st.p && __st.p == "product") {
        return __st.rid;
    }
    else if (typeof __st != 'undefined' && typeof __st.s != 'undefined' &&
        __st.s.substring(0, 9) == 'products-') {
        return __st.s.substring(9);
    }
    const t_id = document.querySelector('div[id=shopify-product-reviews][data-id]');
    if (t_id) {
        return t_id.dataset.id;
    }
    return "";
}
function getBigCommerceProductID() {
    if (typeof productId !== 'undefined') {
        return productId;
    }
    else {
        if (document.querySelector('meta[property="og:type"][content=product]') || (typeof BCData != 'undefined' && BCData.product_attributes)) {
            var p = document.querySelector('input[type=hidden][name=product_id]');
            if (p) {
                return p.value;
            }
        }
    }
    return "";
}
function getWooCommerceProductID() {
    const vars = getScriptParamsByURL("fast-simon-autocomplete-init");
    if (vars && "product_id" in vars) {
        return vars["product_id"];
    }
    let productInput = document.querySelectorAll('input[type=hidden][name=add-to-cart],input[type=hidden][name=product-id]');
    if (productInput.length === 1) {
        return productInput[0].value;
    }
    productInput = document.querySelectorAll('form.variations_form[data-product_id]');
    if (productInput.length === 1) {
        return productInput[0].getAttribute('data-product_id') ?? "";
    }
    return "";
}
function getMagentoProductID() {
    let productID = "";
    const vars = getScriptParamsByURL("fast-simon-autocomplete-init");
    if (vars && "product_id" in vars) {
        productID = vars["product_id"];
    }
    else if (typeof checkout !== 'undefined' && typeof checkout.isp_product_id !== 'undefined') {
        productID = checkout.isp_product_id;
    }
    else if (typeof isp_product_id !== 'undefined') {
        productID = isp_product_id;
    }
    else if (document.body.classList.contains('catalog-product-view')) {
        const p = document.querySelector('input[type=hidden][name=product]');
        if (p) {
            return p.value;
        }
    }
    if (localStorage.getItem("isp_splited_by_color") === 'true' && productID) {
        var urlParams = new URLSearchParams(window.location.search);
        var colorId = urlParams.get('color');
        if (typeof colorId !== "undefined" && colorId !== null) {
            productID += colorId;
        }
    }
    return productID;
}
//# sourceMappingURL=getProductPageID.js.map